import { CircleIcon, InfoIcon } from '../generated'
import { StackIcons } from '../StackIcons'
import type { PredefinedStackProps } from '../PredefinedStackProps'

export const InfoMarkIconStacked = ({ backgroundColor, mainColor, color, ...props }: PredefinedStackProps) => (
  <StackIcons variant="full" {...props}>
    <CircleIcon color={backgroundColor || color} />
    <InfoIcon color={mainColor || color} />
  </StackIcons>
)
